// INDIVIDUAL TEMPLATE
export const TEMPLATE_INDIVIDUAL_START_LISTING =
  "app/Email/TEMPLATE_INDIVIDUAL_START_LISTING";
export const TEMPLATE_INDIVIDUAL_SET_LISTING =
  "app/Email/TEMPLATE_INDIVIDUAL_SET_LISTING";
export const TEMPLATE_INDIVIDUAL_SET_LISTING_ERROR =
  "app/Email/TEMPLATE_INDIVIDUAL_SET_LISTING_ERROR";

//GET ALL TEMPLATE
export const TEMPLATE_START_LISTING = "app/Email/TEMPLATE_START_LISTING";
export const TEMPLATE_SET_LISTING = "app/Email/TEMPLATE_SET_LISTING";
export const TEMPLATE_SET_LISTING_ERROR =
  "app/Email/TEMPLATE_SET_LISTING_ERROR";

// ADD TEMPLATE
export const TEMPLATE_ADD_SUBMIT = "app/Email/TEMPLATE_ADD_SUBMIT";
export const TEMPLATE_ADD_SUCCESS = "app/Email/TEMPLATE_ADD_SUCCESS";
export const TEMPLATE_ADD_FAILURE = "app/Email/TEMPLATE_ADD_FAILURE";

//EDIT TEMPLATE
export const TEMPLATE_SET_EDIT_TEMPLATE = "app/Email/TEMPLATE_SET_EDIT";
export const TEMPLATE_EDIT_SUBMIT = "app/Email/TEMPLATE_EDIT_SUBMIT";
export const TEMPLATE_EDIT_SUCCESS = "app/Email/TEMPLATE_EDIT_SUBMIT";
export const TEMPLATE_EDIT_FAILURE = "app/Email/TEMPLATE_EDIT_SUCCESS";

// SAVE TEMPLATE
export const TEMPLATE_SAVE_SUCCESS = "app/Email/TEMPLATE_SAVE_SUCCESS";
export const TEMPLATE_SAVE_FAILURE = "app/Email/TEMPLATE_SAVE_FAILURE";

//FILTER TEMPLATE
export const TEMPLATE_GET_FILTER_DATA = "app/Email/GET_FILTER_DATA";
export const TEMPLATE_GET_FILTER_DATA_SUCCESS =
  "app/Email/GET_FILTER_DATA_SUCCESS";
export const TEMPLATE_GET_FILTER_DATA_FAILURE =
  "app/Email/GET_FILTER_DATA_FAILURE";
